import { cashApi } from "../api/CashApi";
import { CashModel, CashSessionModel } from "../models/cash/CashModel";

class CashManager {
  private static instance: CashManager;

  public static get(): CashManager {
    if (!this.instance) {
      this.instance = new CashManager();
    }
    return this.instance;
  }

  async getAllCashes(): Promise<CashModel[] | undefined> {
    const result = await cashApi.getAllCashes.requestHard(null);
    console.log("CashManager - getAllCashes result:", result);
    if (!result || !result.data) return [];
    return result.data.map((item: any) => new CashModel(item));
  }

  async updateOrCreateCash(cash: CashModel): Promise<boolean | undefined> {
    const result = await cashApi.updateOrCreateCashes.request({
      cash,
    });
    return result.isSuccess;
  }

  async getCashSession(
    sessionId: string
  ): Promise<CashSessionModel | undefined> {
    const result = await cashApi.getCashSession.requestHard({ sessionId });
    if (!result || !result.data) return undefined;
    return new CashSessionModel(result.data);
  }

  async updateOpeningBalance({
    sessionId,
    openingBalance,
  }: {
    sessionId: string;
    openingBalance: number;
  }): Promise<boolean | undefined> {
    const result = await cashApi.updateOpeningBalance.requestHard({
      sessionId,
      openingBalance,
    });
    return result.isSuccess;
  }

  async closeCashSession({
    sessionId,
    reportedClosingAmount,
  }: {
    sessionId: string;
    reportedClosingAmount: number;
  }): Promise<boolean | undefined> {
    const result = await cashApi.closeCashSession.requestHard({
      sessionId,
      reportedClosingAmount,
    });
    return result.isSuccess;
  }
}

export const cashManager = CashManager.get();
